import { PromotionInterface } from '@e3labs/isa-data-dictionary';
import { formatMessage } from '~/i18n/translate';
import { toDecimals } from '~/utils/format';

export const getPromotionName = (promotion: PromotionInterface) => {
  let promotionName = promotion?.promotionName;

  if (!promotionName) {
    if (promotion?.productExternalCode) {
      promotionName = formatMessage('PromotionCardNameByProduct', {
        externalCode: promotion?.productExternalCode
      });
    } else if (promotion?.brandExternalCode) {
      promotionName = formatMessage('PromotionCardNameByBrand', {
        externalCode: promotion?.brandExternalCode
      });
    } else if (promotion?.sectionExternalCode) {
      promotionName = formatMessage('PromotionCardNameBySection', {
        externalCode: promotion?.sectionExternalCode
      });
    } else if (promotion?.categoryExternalCode) {
      promotionName = formatMessage('PromotionCardNameByCategory', {
        externalCode: promotion?.categoryExternalCode
      });
    } else if (promotion?.departmentExternalCode) {
      promotionName = formatMessage('PromotionCardNameByDepartament', {
        externalCode: promotion?.departmentExternalCode
      });
    } else if (promotion?.providerExternalCode) {
      promotionName = formatMessage('PromotionCardNameByProvider', {
        externalCode: promotion?.providerExternalCode
      });
    } else {
      promotionName = formatMessage('PromotionCardNameByDefault', {
        discount: promotion?.discountPercentage
      });
    }
  }

  return promotionName;
};

export const getPromotionValid = (
  promotions: PromotionInterface[],
  soldQuantity: number | null = null,
  selectedPromotion: PromotionInterface | null = null
) => {
  let validPromotions: PromotionInterface[];
  let defaultPromotion;

  if (!soldQuantity) {
    validPromotions = promotions.sort((a: any, b: any) => {
      if (a?.minimumPrice > b?.minimumPrice) {
        return 1;
      }

      if (a?.minimumPrice < b?.minimumPrice) {
        return -1;
      }

      return 0;
    });

    defaultPromotion =
      validPromotions
        .filter(promotion => promotion.instantApplyDiscount)
        ?.find(promo => promo?.initialQuantity === 1) ?? selectedPromotion;
  } else {
    validPromotions = promotions.filter(
      (promotion: any) =>
        (!promotion?.initialQuantity && !promotion?.finalQuantity) ||
        (!promotion?.initialQuantity && soldQuantity <= promotion?.finalQuantity) ||
        (soldQuantity >= promotion?.initialQuantity && !promotion?.finalQuantity) ||
        (soldQuantity >= promotion?.initialQuantity && soldQuantity <= promotion?.finalQuantity)
    );

    validPromotions.sort((a: any, b: any) => {
      if (a?.minimumPrice > b?.minimumPrice) {
        return 1;
      }

      if (a?.minimumPrice < b?.minimumPrice) {
        return -1;
      }

      return 0;
    });

    const validPromotion = validPromotions?.find(promotion => promotion?._id === selectedPromotion?._id);

    if (selectedPromotion && !!validPromotion) {
      defaultPromotion = validPromotion;
    } else {
      defaultPromotion = validPromotions.find(promotion => promotion.instantApplyDiscount);
    }
  }

  return defaultPromotion;
};

export const validatePromotions = (promotions: PromotionInterface[], soldPrice: number, decimals = 2) => {
  return promotions?.map(validPromotion => {
    let promotionalPrice = validPromotion?.promotionalPrice || 0;
    let addFixedPrice = validPromotion?.addFixedPrice || 0;

    if (!validPromotion?.discountPercentage && !validPromotion?.fixedPrice) {
      promotionalPrice = toDecimals(soldPrice, decimals ?? 2);
    }

    if (validPromotion?.fixedPrice) {
      promotionalPrice = toDecimals(validPromotion?.fixedPrice + addFixedPrice, decimals ?? 2);
    }

    //! Comentado pois o desconto é aplicado automaticamente no order-create-sagas.ts
    // if (validPromotion?.discountPercentage) {
    //   promotionalPrice = toDecimals(soldPrice - (soldPrice * validPromotion?.discountPercentage) / 100, decimals ?? 2);
    // }

    return {
      ...validPromotion,
      promotionName: getPromotionName(validPromotion),
      initialQuantity: validPromotion?.initialQuantity ?? 1,
      finalQuantity: validPromotion?.finalQuantity ?? 99999,
      promotionalPrice
    };
  });
};
